import { ComponentChildren } from 'preact'

import styles from './index.module.css'

export function Button({ children, onClick }: { children: ComponentChildren; onClick: () => void }) {
  return (
    <button class={styles.button} onClick={onClick}>
      {children}
    </button>
  )
}
